/* Static wash rows standing in for table or list rows (DESIGN.md §5): flat, ruled like
   the rows they replace, no shimmer. */
.block {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--paper);
}

.row {
  height: var(--row-height);
  border-bottom: 1px solid var(--paper);
  background: var(--wash);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
